import React from 'react'
import { Navbar } from '@sketch/components'
import { ShareWithoutVersion } from 'modules/versioning'
import BackButton, { useBackButton } from 'modules/shares/components/BackButton'
import HeaderBadge from 'modules/shares/components/HeaderBadge'
import * as S from './PrototypeHeader.styles'

type PrototypeEmptyHeaderProps = {
  setSidebarLeftOpen?: React.Dispatch<React.SetStateAction<boolean>>
  share: ShareWithoutVersion
}

/**
 * A bare-bones header to show while the Prototype is loading, or in an error
 * state.
 */
export function PrototypeEmptyHeader(props: PrototypeEmptyHeaderProps) {
  const { setSidebarLeftOpen, share } = props
  const { link: shouldRenderBackButton } = useBackButton()
  return (
    <Navbar data-testid="prototype-empty-header">
      <Navbar.Section>
        <HeaderBadge
          workspace={share.workspace}
          setSidebarLeftOpen={setSidebarLeftOpen}
        />
        {shouldRenderBackButton && (
          <S.BackButtonItem>
            <BackButton />
          </S.BackButtonItem>
        )}
      </Navbar.Section>
    </Navbar>
  )
}
